module.exports = __webpack_public_path__ + "img/icon-64.eff5752f.svg";